/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Impersonation_ExitingInputs */

const vi_impersonation_exiting = /** @type {(inputs: Impersonation_ExitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang thoát...`)
};

/**

* @param {Impersonation_ExitingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const impersonation_exiting = /** @type {((inputs?: Impersonation_ExitingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Impersonation_ExitingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_impersonation_exiting(inputs)
});